module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"title":"Setup your password","spf":"Set password for","pc":"Password confirmation","pmbe":"Passwords must be equal","register":"register"},"fr":{"title":"Configurez votre mot de passe","spf":"Configurer le mot de passe pour","pc":"Confirmation du mot de passe","pmbe":"Les mots de passes doivent ètre egale","register":"s\u0027inscrir"}}')
  delete Component.options._Ctor
}
